(function () {
  const STORAGE_KEY = 'sunarloji_wishlist';
  const TEMPLATE = 'product-item';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateUI();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
  }

  function normalizeProduct(el) {
    const source = el.dataset.productId ? el : el.querySelector('[data-product-id]');
    if (!source) return null;

    return {
      id: String(source.dataset.productId || ''),
      handle: source.dataset.productHandle || '',
      url: source.dataset.productUrl || ''
    };
  }

  function getLabels() {
    return window.wishlistLabels || { add: 'Add to wishlist', remove: 'Remove from wishlist' };
  }

  function setToggleState(toggle, active) {
    const icon = toggle.querySelector('i[class*="icon-heart"]');
    if (!icon) return;

    const labels = getLabels();
    const control = toggle.matches('button') ? toggle : toggle.querySelector('button') || toggle;

    toggle.classList.toggle('is-wishlisted', active);
    toggle.setAttribute('aria-pressed', active ? 'true' : 'false');
    control.setAttribute('aria-label', active ? labels.remove : labels.add);

    if (active) {
      icon.classList.remove('icon-heart-outline');
      icon.classList.add('icon-heart');
    } else {
      icon.classList.remove('icon-heart');
      icon.classList.add('icon-heart-outline');
    }
  }

  function updateUI() {
    const list = getWishlist();
    const ids = list.map(function (item) {
      return String(item.id);
    });

    document.querySelectorAll('.wishlist-toggle').forEach(function (toggle) {
      const productId = toggle.dataset.productId;
      if (!productId) return;
      setToggleState(toggle, ids.includes(String(productId)));
    });

    document.querySelectorAll('.wishlist-count').forEach(function (badge) {
      badge.textContent = String(list.length);
    });
  }

  function toggleWishlist(product) {
    if (!product || !product.id) return;

    let list = getWishlist();
    const index = list.findIndex(function (item) {
      return String(item.id) === String(product.id);
    });

    if (index >= 0) {
      list.splice(index, 1);
    } else {
      list.push({
        id: String(product.id),
        handle: product.handle || '',
        url: product.url || '/products/' + product.handle
      });
    }

    saveWishlist(list);
  }

  function parseProductMarkup(text) {
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const section = doc.getElementById('shopify-section-' + TEMPLATE);
    if (!section) return '';

    const li = section.querySelector('li');
    return li ? li.outerHTML : section.innerHTML;
  }

  async function fetchProductMarkup(product) {
    const url = (product.url || '/products/' + product.handle) + '/?section_id=' + TEMPLATE;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Product not found');
    }

    const text = await response.text();
    return parseProductMarkup(text);
  }

  async function renderPage(container) {
    if (!container) return;

    const sectionEl = container.closest('.wishlist-section, [data-wishlist-section]');
    const emptyState = sectionEl?.querySelector('.wishlist-empty');
    const list = getWishlist();
    const grid = container;
    const isEmpty = !list.length;

    grid.innerHTML = '';

    if (sectionEl) {
      sectionEl.classList.toggle('wishlist-section--empty', isEmpty);
    }

    if (isEmpty) {
      if (emptyState) emptyState.classList.remove('hidden');
      return;
    }

    if (emptyState) emptyState.classList.add('hidden');

    const validItems = [];
    const markupResults = await Promise.all(
      list.map(async function (product) {
        try {
          const markup = await fetchProductMarkup(product);
          if (!markup) throw new Error('Empty markup');
          validItems.push(product);
          return markup;
        } catch (e) {
          return null;
        }
      })
    );

    if (validItems.length !== list.length) {
      saveWishlist(validItems);
    }

    markupResults.filter(Boolean).forEach(function (markup) {
      grid.insertAdjacentHTML('beforeend', markup);
    });

    updateUI();
  }

  function handleClick(event) {
    const toggle = event.target.closest('.wishlist-toggle');
    if (!toggle) return;

    const product = normalizeProduct(toggle);
    if (!product) return;

    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(product);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('wishlist:updated', function () {
    document.querySelectorAll('.wishlist-page-grid').forEach(function (grid) {
      renderPage(grid);
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    updateUI();

    document.querySelectorAll('.wishlist-page-grid').forEach(function (grid) {
      renderPage(grid);
    });
  });

  window.SunarlojiWishlist = {
    getWishlist: getWishlist,
    saveWishlist: saveWishlist,
    toggleWishlist: toggleWishlist,
    updateUI: updateUI,
    renderPage: renderPage
  };
})();
